import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const mealConfigForm = (strings: any, mealPlans: []): FormModel[] => {
  return [
    {
      label: strings.meal_plan_column_name,
      value: {},
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'name',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      responsive: { xs: 12, sm: 6, xl: 12 },
      options: mealPlans,
    },
    {
      label: strings.meal_plan_price_column_name,
      value: '',
      typeValue: 'number',
      type: 'text',
      placeholder: '',
      field: 'price',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat }],
      required: true,
      responsive: { xs: 12, sm: 6, xl:12 },
    },
  ];
};
